module.exports = __webpack_public_path__ + "static/img/onlineconsult.394ff7c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onlineconsult.jpeg
// module id = 669
// module chunks = 1